"use client";
import { useEffect, useMemo, useState } from "react";

const useFetchBlobUrl = (urlToBeConvertedToBlobUrl) => {
  const [blobUrl, setBlobUrl] = useState("");
  useEffect(() => {
    if (urlToBeConvertedToBlobUrl) {
      fetch(urlToBeConvertedToBlobUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          setBlobUrl(blobUrl);
        });
    }
  }, [urlToBeConvertedToBlobUrl]);

  return useMemo(() => ({ blobUrl }), [blobUrl]);
};

export default useFetchBlobUrl;
